export default __webpack_public_path__ + "static/media/codeBtn.220a25ed.png";